import React, { useState, useEffect } from 'react';
import './MaintenancePage.css';

function MaintenancePage({ message, endTime, onRetry }) {
    const [countdown, setCountdown] = useState(null);
    const [appName, setAppName] = useState('iMoney');

    useEffect(() => {
        // Fetch branding
        fetch('/api/branding')
            .then(res => res.json())
            .then(data => {
                if (data.app_name) setAppName(data.app_name);
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        if (!endTime) return;

        const updateCountdown = () => {
            const now = new Date();
            const end = new Date(endTime);
            const diff = end - now;

            if (diff <= 0) {
                setCountdown(null);
                // Auto retry when time is up
                if (onRetry) {
                    onRetry();
                }
                return;
            }

            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            setCountdown({ hours, minutes, seconds });
        };

        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);

        return () => clearInterval(interval);
    }, [endTime, onRetry]);

    const formatEndTime = () => {
        if (!endTime) return null;
        const date = new Date(endTime);
        return date.toLocaleString('th-TH', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="maintenance-container">
            <div className="maintenance-content">
                <div className="maintenance-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
                    </svg>
                </div>

                <h1>{appName}</h1>
                <h2>ระบบปิดปรับปรุงชั่วคราว</h2>

                <p className="maintenance-message">
                    {message || 'ขณะนี้ระบบอยู่ระหว่างการปรับปรุง กรุณากลับมาใหม่ภายหลัง'}
                </p>

                {endTime && (
                    <div className="expected-time">
                        <p>คาดว่าจะกลับมาใช้งานได้:</p>
                        <p className="time-value">{formatEndTime()}</p>

                        {countdown && (
                            <div className="countdown">
                                <div className="countdown-item">
                                    <span className="number">{String(countdown.hours).padStart(2, '0')}</span>
                                    <span className="label">ชั่วโมง</span>
                                </div>
                                <span className="separator">:</span>
                                <div className="countdown-item">
                                    <span className="number">{String(countdown.minutes).padStart(2, '0')}</span>
                                    <span className="label">นาที</span>
                                </div>
                                <span className="separator">:</span>
                                <div className="countdown-item">
                                    <span className="number">{String(countdown.seconds).padStart(2, '0')}</span>
                                    <span className="label">วินาที</span>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <div className="maintenance-footer">
                    <p>ขออภัยในความไม่สะดวก</p>
                    {onRetry && (
                        <button onClick={onRetry} className="retry-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 2v6h-6M3 12a9 9 0 0 1 15-6.7L21 8M3 22v-6h6M21 12a9 9 0 0 1-15 6.7L3 16"/>
                            </svg>
                            ลองอีกครั้ง
                        </button>
                    )}
                </div>
            </div>

            <div className="maintenance-bg">
                <div className="gear gear-1"></div>
                <div className="gear gear-2"></div>
                <div className="gear gear-3"></div>
            </div>
        </div>
    );
}

export default MaintenancePage;
